import React from "react";

const FAQ = () => {
  const items = [
    {
      q: "Maxula, c’est quoi exactement ?",
      a: "Maxula.ma est un centre de réservation et de mise en relation entre les clients et nos partenaires (spas, restaurants, hôtels, voyages, immobilier, services VIP…)."
    },
    {
      q: "Depuis quand existe Maxula ?",
      a: "Depuis 2013, nous offrons une expérience fiable, premium et transparente à nos clients marocains et étrangers."
    },
    {
      q: "Comment fonctionne une offre / coupon ?",
      a: "Vous choisissez une offre, vous payez (lien CMI ou autre mode possible), vous recevez un coupon/confirmation, puis vous réservez et profitez chez le partenaire avant la date de validité."
    },
    {
      q: "Puis-je payer directement chez le prestataire ?",
      a: "Non. Aucun paiement direct ne doit être effectué chez le prestataire. Le paiement se fait via Maxula (voir CGV)."
    },
    {
      q: "Annulation / remboursement ?",
      a: "Les règles dépendent du pôle (Experiences / Laser Clinic / House). Consultez la page CGV pour les détails complets."
    },
    {
      q: "Devenir partenaire : mon nom sera public ?",
      a: "Non. Pour protéger votre image et vos tarifs : votre nom n’apparaît pas sur les réseaux sociaux, ni sur le site ; il n’apparaît qu’après achat, sur le coupon."
    }
  ];

  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[300px] md:h-[360px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                FAQ
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Réponses rapides aux questions les plus fréquentes.
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.55) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-12 bg-[#fff3f8]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          {items.map((it) => (
            <div key={it.q} className="bg-white border rounded-2xl p-6">
              <div className="font-bold text-gray-900">{it.q}</div>
              <div className="mt-2 text-gray-700 leading-relaxed">{it.a}</div>
            </div>
          ))}
          <div className="text-center text-sm text-gray-600 pt-2">
            Pour les règles officielles : consultez la page <b>CGV</b>.
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
